// Error instances don't serialize via JSON.stringify because their key
// properties (name/message/stack) are non-enumerable, leaving log payloads
// like { err } as the empty `{}` seen in DB_INIT_ERROR. The replacer below
// converts any Error encountered (top-level or nested) into a plain object
// with name + message. Stack is omitted — minified prod stacks are unreadable
// in the event log TSV anyway, and Sentry.captureException already stores the
// source-mapped stack alongside (look up by timestamp/userId to see it).
export function errorReplacer(_key: string, value: unknown): unknown {
  if (value instanceof Error) {
    return {
      name: value.name,
      message: value.message,
    };
  }

  return value;
}

export function serializeLogData(data: unknown): string {
  return JSON.stringify(data, errorReplacer);
}
